import React from "react";
import { TrendingDown, TrendingUp } from "lucide-react";

function formatPercentValue(value) {
  const num = Number(value);
  if (Number.isFinite(num)) {
    return Number.isInteger(num) ? String(num) : num.toFixed(1);
  }

  return String(value || 0);
}

export default function CardStats({
  statSubtitle = "Traffic",
  statTitle = "350,897",
  statArrow = "up",
  statPercent = "3.48",
  statPercentColor = "text-emerald-500",
  statDescription = "Since last month",
  statFooterMessage = "",
  statFooterColorClass = "text-gray-600",
  hidePercent = false,
  statIcon = null,
  statIconName = "far fa-chart-bar",
  statIconColor = "bg-red-500",
  loading = false,
}) {
  const isUp = statArrow === "up";
  const isDown = statArrow === "down";
  const showTrend = isUp || isDown;

  if (loading) {
    return (
      <>
        <div
          className="relative flex flex-col min-w-0 break-words bg-white"
          style={{
            minHeight: 112,
            borderRadius: "18px",
            border: "1px solid #d5e1f0",
            boxShadow: "0 8px 18px rgba(15, 23, 42, 0.05)",
            backgroundImage: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
          }}
        >
          <div className="flex-auto px-4 py-2 flex flex-col justify-center" style={{ paddingTop: 7, paddingBottom: 7 }}>
            <div className="flex flex-wrap items-center">
              <div className="relative w-full pr-4 max-w-full flex-grow flex-1 min-w-0">
                <div className="h-3 w-24 rounded bg-slate-200 animate-pulse mb-2" />
                <div className="h-7 w-20 rounded bg-slate-200 animate-pulse" />
              </div>
              <div className="relative w-auto pl-2 flex-initial">
                <div className="w-[46px] h-[46px] rounded-2xl bg-slate-200 animate-pulse" />
              </div>
            </div>
            <div className="h-3 w-44 rounded bg-slate-200 animate-pulse mt-2" />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        className="relative flex flex-col min-w-0 break-words bg-white"
        style={{
          minHeight: 112,
          borderRadius: "18px",
          border: "1px solid #d5e1f0",
          boxShadow: "0 8px 18px rgba(15, 23, 42, 0.05)",
          backgroundImage: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
        }}
      >
        <div className="flex-auto px-4 py-2 flex flex-col justify-center" style={{ paddingTop: 7, paddingBottom: 7 }}>
          <div className="flex flex-wrap items-center">
            <div className="relative w-full pr-4 max-w-full flex-grow flex-1 min-w-0">
              <h5
                className="font-medium whitespace-nowrap leading-tight"
                style={{ fontSize: "0.74rem", color: "#334e73" }}
              >
                {statSubtitle}
              </h5>
              <span
                className="font-bold"
                style={{
                  color: "#0f172a",
                  fontSize: "1.45rem",
                  lineHeight: 1,
                  letterSpacing: "-0.03em",
                }}
              >
                {statTitle}
              </span>
            </div>
            <div className="relative w-auto pl-2 flex-initial">
              <div
                className={
                  "text-center inline-flex items-center justify-center rounded-2xl " +
                  statIconColor
                }
                style={{
                  width: 46,
                  height: 46,
                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.6)",
                }}
              >
                {statIcon || <i className={statIconName}></i>}
              </div>
            </div>
          </div>
          <p
            className="text-sm mt-1 flex items-center gap-1"
            style={{
              color: "#64748b",
              fontSize: hidePercent ? "0.65rem" : "0.72rem",
              columnGap: "0.32rem",
            }}
          >
            {hidePercent ? (
              <span className={statFooterColorClass} style={{ fontWeight: 500, lineHeight: 1.2 }}>
                {statFooterMessage || statDescription}
              </span>
            ) : (
              <>
                <span className={statPercentColor + " inline-flex items-center gap-1 font-semibold"}>
                  {showTrend ? (
                    isUp ? <TrendingUp size={11} strokeWidth={2.2} /> : <TrendingDown size={11} strokeWidth={2.2} />
                  ) : null}
                  {showTrend ? (isUp ? "+" : "-") : ""}
                  {formatPercentValue(Math.abs(Number(statPercent)))}%
                </span>
                <span className="whitespace-nowrap" style={{ color: "#46638a", fontWeight: 500 }}>
                  {statDescription}
                </span>
              </>
            )}
          </p>
        </div>
      </div>
    </>
  );
}